import React, { useContext, useState } from "react";
import { SiteContext } from "gatsby-frontend/src/Site";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

function Cart({ form, disabled }) {
	const { cartItems, setCartItems } = useContext(SiteContext);
	const [cartGroups, setCartGroups] = useState(() => {
		let _groups = {};
		cartItems.forEach((item) => {
			if (!_groups[item.id]) {
				_groups[item.id] = {
					...item,
					quantity: 1,
				};
			} else {
				_groups[item.id].quantity += 1;
			}
		});
		return _groups;
	});

	if (!cartGroups) return null;

	return (
		<Box>
			<TableContainer>
				<Table aria-label="cart products">
					<TableBody>
						{Object.entries(cartGroups).map(
							([product_id, { quantity, title, type }], index) => (
								<TableRow
									key={product_id}
									sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
								>
									<TableCell component="th" scope="row">
										<Typography variant="h4">{title}</Typography>
									</TableCell>
									<TableCell align="right" sx={{ width: "130px" }}>
										<TextField
											type="number"
											min={1}
											value={quantity}
											disabled={form.isSubmitting || disabled}
											onChange={(e) => {
												let _cartGroups = { ...cartGroups };
												let qty = parseInt(e.target.value);
												_cartGroups[product_id].quantity = qty;
												let _cartItems = [];
												Object.entries(_cartGroups).forEach(
													([product_id, { quantity, title, type }]) => {
														for (let i = 0; i < quantity; i++) {
															_cartItems.push({ id: product_id, title, type });
														}
													}
												);
												if (!qty) delete _cartGroups[product_id];
												setCartItems(_cartItems);
												setCartGroups(_cartGroups);
											}}
										/>
									</TableCell>
									<TableCell sx={{ width: "70px" }}>
										<IconButton
											aria-label="delete"
											onClick={() => {
												let _cartGroups = { ...cartGroups };
												delete _cartGroups[product_id];
												let _cartItems = cartItems.filter((item) => {
													return item.id !== product_id;
												});

												setCartItems(_cartItems);
												setCartGroups(_cartGroups);
											}}
											disabled={form.isSubmitting || disabled}
										>
											<DeleteIcon />
										</IconButton>
									</TableCell>
								</TableRow>
							)
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
}

export default Cart;
